import {
  NEW_FIELD_CHANGE_COURSES,
  OPEN_NEW_DIALOG_COURSES,
  CLOSE_NEW_DIALOG_COURSES,
  ADD_NEW_COURSES,
  ADDED_COURSES,
  SET_RECURRING_DATA,
} from './actions';

import { INITIATE_FIELDS_COURSES } from '../../actions';

const initialState = {
  pending: false,
  isDirty: false,
  open: false,
  error: null,
  isValid: true,
  data: null,
  fieldsData: {},
  isRecurringCourse: false,
  recurringType: 'weeks',
  recurringValue: 2,
};

const newCourseReducer = (state = initialState, action) => {
  switch (action.type) {
    case INITIATE_FIELDS_COURSES:
      return {
        ...state,
        fieldsData: action.value,
        fieldsMockData: action.value,
      };
    case SET_RECURRING_DATA:
      return {
        ...state,
        [action.id]: action.value,
      };

    case OPEN_NEW_DIALOG_COURSES:
      return {
        ...state,
        open: true,
      };

    case CLOSE_NEW_DIALOG_COURSES:
      return {
        ...state,
        open: false,
      };

    case NEW_FIELD_CHANGE_COURSES:
      return {
        ...state,
        fieldsData: {
          ...state.fieldsData,
          [action.id]: {
            value: action.value,
            isValid: action.isValid,
            type: action.prop,
          },
        },
      };

    case ADD_NEW_COURSES:
      return {
        ...state,
        pending: true,
      };

    case ADDED_COURSES:
      return {
        ...initialState,
        fieldsData: state.fieldsMockData,
        fieldsMockData: state.fieldsMockData,
      };

    default:
      return state;
  }
};

export default newCourseReducer;
